import { jsx } from '@emotion/react/jsx-runtime';
import { compound, createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { Rectangle } from '@nettbureau/shape';
import { useCss } from '@nettbureau/styling';
import { CardBody } from './card-body.js';
import { CardProvider } from './card-context.js';
import { CardFooter } from './card-footer.js';
import { CardHeader } from './card-header.js';

/**
 * Cards contain content and actions about a single subject in a compact container. They should be
 * easy to scan for relevant and actionable information.
 */ const Card = compound('Card', createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Card', props, ref);
    const { borderRadius = 'lg', children, color, css, layout, padding = 'md', shadow, variant = 'elevated', ...elementProps } = mergedProps;
    const fill = variant === 'elevated' ? 'base' : color;
    const fillTone = variant === 'filled' ? 'medium' : 'soft';
    const cardCss = useCss({
        '& img': {
            display: 'block'
        }
    });
    return /*#__PURE__*/ jsx(Rectangle, {
        "data-card": true,
        ...elementProps,
        ref: mergedRef,
        borderRadius: borderRadius,
        css: [
            cardCss,
            css
        ],
        fill: fill,
        fillTone: fillTone,
        layout: {
            direction: 'vertical',
            ...layout
        },
        outlineTone: fill === 'base' ? 'weak' : 'none',
        shadow: shadow ?? (fill === 'base' ? 'weaker' : 'none'),
        children: /*#__PURE__*/ jsx(CardProvider, {
            value: {
                padding
            },
            children: children
        })
    });
}), {
    Header: CardHeader,
    Body: CardBody,
    Footer: CardFooter
});

export { Card };
//# sourceMappingURL=card.js.map
